import type { Auth } from "@staffsmith/web-auth";
import { createContext, useContext } from "react";
import type { Api } from "./api.js";

// What every page needs: the API client, sign-in, and the staff app's address.
export type AppServices = { api: Api; auth: Auth; staffAppUrl: string };

export const Services = createContext<AppServices | null>(null);

export function useServices(): AppServices {
  const services = useContext(Services);
  if (!services) throw new Error("useServices outside <Services.Provider>");
  return services;
}

export const useApi = () => useServices().api;
